import { Button, Spin, Table, Tooltip } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { IoInformationCircleOutline } from "react-icons/io5";

const TradeHistorySpot = (props) => {
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [CheckBal, setCheckBal] = useState([]);
  const [secondApiData, setSecondApiData] = useState(null);
  const { type, apiKey,apiSecret,selectedapi } = props?.data;
  console.log(props?.data)
  const createdAt = selectedapi?.datetime;
  const startTime = new Date(createdAt).getTime()
  const symbols = ["BTCUSDT", "ETHUSDT", "BNBUSDT","XRPUSDT","SOLUSDT","MANAUSDT","DOGEUSDT"];

  const checkSpotBalance = async () => {
    setCheckBal(null);
    setLoading(true);
    const token = localStorage.getItem("jwt");

    try {
      const allOrders = [];

      
      for (const symbol of symbols) {
        const secondApiData = {
          request_type: "private",
          method: "GET",
          key: apiKey,
          secret: apiSecret,
          endpoint: "/api/v3/allOrders",
          params: { 
            symbol: symbol,
            limit:40,
            // startTime:startTime 
          }, 
        };

        const secondRes = await axios({
          method: "POST",
          headers: { "Content-Type": "application/json" },
          url: process.env.REACT_APP_API_ALLCOINS + "/make_request",
          data: secondApiData,
        });

      
        allOrders.push(...secondRes.data.Success);
      }

     
      const formattedData = allOrders.map((order) => ({
        transactTime: new Date(order.time).toLocaleString() ,
        orderId: order.orderId,
        symbol: order.symbol,
        type: order.type,
        side: order.side,
        timeInForce: order.timeInForce,
        price: (order.cummulativeQuoteQty/order.executedQty),
        origQty: order.origQty,
        executedQty: order.executedQty,
        cummulativeQuoteQty: order.cummulativeQuoteQty,
        fills: order.fills || [], 
        status:order.status
      }));

      setHistoryData(formattedData); 
      setLoading(false);

    } catch (err) {
      setLoading(false);
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    if(selectedapi){
    checkSpotBalance();
    }
  }, [selectedapi]);

  const sortedHistoryData = historyData?.length > 0
? [...historyData].sort((a, b) => new Date(b.time) - new Date(a.time)) 
: [];

  const dataSource = sortedHistoryData.length > 0
    ? sortedHistoryData
    : [
        {
          transactTime: <p className="p-1 rounded-lg text-center">*****</p>,
          orderId: <p className="p-1 rounded-lg text-center">*****</p>,
          symbol: <p className="p-1 rounded-lg text-center">*****</p>,
          type: <p className="p-1 rounded-lg text-center">*****</p>,
          side: <p className="p-1 rounded-lg text-center">*****</p>,
          price: <p className="p-1 rounded-lg text-center">*****</p>,
          origQty: <p className="p-1 rounded-lg text-center">*****</p>,
          executedQty: <p className="p-1 rounded-lg text-center">*****</p>,
          status: <p className="p-1 rounded-lg text-center">*****</p>,
        },
      ];

  const columns = [
    { title: 'Trans Time', dataIndex: 'transactTime', key: 'transactTime' },
    { title: 'Order ID', dataIndex: 'orderId', key: 'orderId' },
    { title: 'Symbol', dataIndex: 'symbol', key: 'symbol' },
    { title: 'Type', dataIndex: 'type', key: 'type' },
    { title: 'Side', dataIndex: 'side', key: 'side' },
    
    { title: 'Price', dataIndex: 'price', key: 'price' },
    { title: <Tooltip title="Original Quantity">O Qty</Tooltip>, dataIndex: 'origQty', key: 'origQty' },
    { title: <Tooltip title="Executed Quantity">E Qty</Tooltip>, dataIndex: 'executedQty', key: 'executedQty' },
    { title: <Tooltip title="">Status</Tooltip>, dataIndex: 'status', key: 'status' },

  ];

  return (
    <div>
      <Spin spinning={loading} >
        <Table columns={columns} dataSource={dataSource}
          className=' overflow-x-scroll'
          size='small'
          bordered
        />
      </Spin>
      <div className="flex items-center gap-1 my-2 ">
        <IoInformationCircleOutline />
        <p className="text-xs">Displays the order history for the past 7 days only.</p>
      </div>

    </div>
  );
};

export default TradeHistorySpot;
